import { EDevice } from '@constants';

export const detectDevice = (): EDevice => {
  const userAgent = navigator.userAgent.toLowerCase();
  return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent)
    ? EDevice.MOBILE
    : EDevice.WEB;
};
